import { CSSObject } from '@chakra-ui/react';

export const WrapperContent: CSSObject = {
  display: 'flex',
  flexDir: 'column',
  py: ['4', null, '10'],
  px: ['2', null, '10'],
  flex: [null, null, 1],
  justifyContent: [null, null, 'center'],
  maxW: ['100vw', null, '500px'],
  bg: 'alpha.300',
  borderRightRadius: ['unset', null, 'lg'],
  '.chakra-form__label': {
    color: 'white',
  },
  'input:-webkit-autofill, input:-webkit-autofill:focus': {
    transition: 'background-color 0s 600000s, color 0s 600000s',
  },
  '.chakra-input__right-element': {
    color: 'beta.500',
  },
  '.chakra-form__error-message': {
    bg: 'red.600',
    boxShadow:
      '0px 2px 4px 0px rgba(0, 0, 0, 0.20), 0px 1px 0px 0px rgba(255, 255, 255, 0.20) inset',
    borderRadius: 'base',
    p: '1',
    color: 'white',
    fontWeight: 'medium',
    fontSize: 'xs',
  },
  '#title-dropdown-select, #state-select, #suburb-input, #postcode-input, #residential-input, #streetName-input, #streetNumber-input':
    {
      borderRadius: 'md',
      bg: 'blackAlpha.500',
      color: 'white',
      border: 'none',
      boxShadow:
        '0px 1px 5px 0px rgba(0, 0, 0, 0.15) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.10)',
      option: {
        color: 'black',
      },
    },
  '.chakra-select__icon-wrapper': {
    color: 'white',
  },
  'button[aria-label*="password toggle"]': {
    top: '-1px',
    color: 'gamma.300',
  },
};
